'use client';
import React, { useState, useEffect } from 'react';
import MarketingNav from '@/app/marketing/components/MarketingNav';
import MarketingFooter from '@/app/marketing/components/MarketingFooter';
import ContactPageClient from './ContactPageClient';
import { createClient } from '@/lib/supabase/client';
import type { PublicContactSettings } from '@/lib/contact-settings/schema';
import { CONTACT_SETTINGS_FALLBACK } from '@/lib/contact-settings/fallback';

export default function ContactPage() {
  const [settings, setSettings] = useState<PublicContactSettings>(CONTACT_SETTINGS_FALLBACK);

  useEffect(() => {
    const supabase = createClient();
    supabase
      .from('contact_settings')
      .select('*')
      .eq('id', 'singleton')
      .single()
      .then(({ data }) => {
        if (!data) return;
        const row = data as Record<string, unknown>;
        const clean = <T,>(v: T | null | undefined): T | null =>
          v === '' || v === undefined ? null : (v ?? null);
        setSettings({
          companyName: (row.company_name as string) || CONTACT_SETTINGS_FALLBACK.companyName,
          supportEmail: (row.support_email as string) || CONTACT_SETTINGS_FALLBACK.supportEmail,
          salesEmail: clean(row.sales_email as string),
          phonePrimary: (row.phone_primary as string) || CONTACT_SETTINGS_FALLBACK.phonePrimary,
          phoneWhatsapp: clean(row.phone_whatsapp as string),
          lineId: clean(row.line_id as string),
          addressLine1: (row.address_line1 as string) || '',
          addressLine2: clean(row.address_line2 as string),
          city: (row.city as string) || '',
          country: (row.country as string) || '',
          mapEmbedUrl: clean(row.map_embed_url as string),
          officeHours: Array.isArray(row.office_hours)
            ? row.office_hours
            : CONTACT_SETTINGS_FALLBACK.officeHours,
          timezoneLabel: (row.timezone_label as string) || 'ICT',
          responseTimeNote: (row.response_time_note as string) || '',
          urgentContactNote: (row.urgent_contact_note as string) || '',
          socialLinks:
            row.social_links && typeof row.social_links === 'object'
              ? (row.social_links as PublicContactSettings['socialLinks'])
              : {},
          demoBookingUrl: (row.demo_booking_url as string) || '/demo',
          pricingUrl: (row.pricing_url as string) || '/pricing',
          loginUrl: (row.login_url as string) || '/auth',
          isActive: (row.is_active as boolean) ?? true,
          updatedByName: clean(row.updated_by_name as string),
          updatedAt: (row.updated_at as string) || undefined,
        });
      });
  }, []);

  return (
    <div
      className="min-h-screen bg-[#0a0e1a] text-[#e5e7eb]"
      style={{ fontFamily: 'var(--font-plus-jakarta-sans), system-ui, sans-serif' }}
    >
      <MarketingNav />
      <main id="main-content">
        <ContactPageClient settings={settings} />
      </main>
      <MarketingFooter />
    </div>
  );
}
